export default function AccessibilityTab() {
    return (
        <h2>Accessibility</h2>
    );
}